<script setup lang="ts">
import JournalPage from '@/pages/journal';
</script>

<template>
  <JournalPage />
</template>
